const mapButton = {
  fontSize: '10px',
  display: 'flex',
  flexDirection: 'column',
  '&:first-of-type': {
    marginRight: '.5rem'
  },
  '&:hover': {
    color: 'blue',
    '& img, div': {
      border: '2px solid blue'
    }
  }
}

export default {
  container: {
    zIndex: 10,
    lineHeight: '1.6rem',
    position: 'absolute',
    padding: '5px 5px 5px',
    bottom: 0,
    marginBottom: '25px',
    display: 'flex',
    textAlign: 'center',
    fontSize: '10px',
    '& img': {
      borderRadius: '8px',
      width: '65px',
      height: '65px'
    },
  },
  mapTypeButton: {
    background: '#ffffff',
    borderRadius: '8px',
    padding: '5px 5px 5px',
    display: 'flex',
    flexDirection: 'column',
    marginRight: '1rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #00001E'
  },
  mapTypesContainer: {
    background: '#ffffff',
    borderRadius: '8px',
    padding: '5px 5px 5px',
    display: 'flex',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #00001E'
  },
  mapButton,
  blankView: {
    fontSize: '10px',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '8px',
    width: '65px',
    height: '65px',
    backgroundColor: 'rgb(229, 227, 223)'
  },
  blockClick: {
    cursor: 'not-allowed',
    '& *': {
      cursor: 'not-allowed'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/MapComponents/MapTypeButtons/style.js